import React, { useEffect, useRef } from 'react';

const SamanKishTokenForm = ({ token }) => {
  let currentUrl = window.location.href;
  currentUrl = document.URL;
  currentUrl = new URL(window.location);
  currentUrl = currentUrl.origin;

  const formRef = useRef(null);

  useEffect(() => {
    if (formRef.current && token) {
      formRef.current.submit();
    }
  }, [token]);

  return (
    <React.Fragment>
      <form
        ref={formRef}
        action="https://sep.shaparak.ir/OnlinePG/OnlinePG"
        method="post"
        style={{
          display: 'none',
        }}
      >
        <br />
        <input
          type="text"
          value={`${currentUrl}/verifysamankish`}
          name="RedirectURL"
          readOnly
        />
        <br />
        <input
          type="text"
          value={`${token}`}
          name="Token"
          readOnly
        />
        <br />
        <input
          type="text"
          value="true"
          name="GetMethod"
          readOnly
        />
        <br />
        <br />
        <input type="submit" text="submit" readOnly />
      </form>
    </React.Fragment>
  );
};

export default SamanKishTokenForm;
